import { Component } from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';
import {KeyValue} from '../../shared/key-value';

import {AuthorizationService} from '../../shared/authorization.service';

@Component({
  selector: 'app-execution-popup',
  templateUrl: './execution-popup.component.html',
  styleUrls: ['./execution-popup.component.css']
})
export class ExecutionPopupComponent {

  constructor(private router: Router, private _tokenService: AngularTokenService,
    public authService: AuthorizationService, private KeyValueService: KeyValue) {

  }
}
